export default __webpack_public_path__ + "static/media/SEN-POW-PRE.3e910305.png";